import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CanDeactivate } from '@angular/router';
import { BriefingComponent } from '../../Briefings/components/Briefing/briefing.component';
import { BriefingsService } from '../../Briefings/services/briefings.service';
import { MonitoringRoutingService } from '../../Core/services/monitoring-routing.service';
import { RouteType } from '../../Shared/enums/route-type.enum';

@Injectable()
export class BriefingDeactivateGuard implements CanDeactivate<BriefingComponent> {
    constructor(
        public briefingsService: BriefingsService,
        public monitoringRoutingService: MonitoringRoutingService
    ) {}

    canDeactivate(
        component: BriefingComponent
    ): Observable<boolean> {
        const destinationRoute = this.monitoringRoutingService.getNextRoute();

        if (
            destinationRoute &&
            destinationRoute.type === RouteType.briefing &&
            !destinationRoute.value
        ) {
            // New briefing case, the amplify dialog checks for unsaved before it opens, when navigation happens it's already been asked, don't ask again
            return of(true);
        }

        return this.briefingsService.showCanLeaveDialog();
    }
}
